module.exports = __webpack_public_path__ + "static/media/settings.3fa760a0.svg";